import { render, staticRenderFns } from "./flow2.vue?vue&type=template&id=61d70fbe&scoped=true&"
import script from "./flow2.vue?vue&type=script&lang=js&"
export * from "./flow2.vue?vue&type=script&lang=js&"
import style0 from "./flow2.vue?vue&type=style&index=0&id=61d70fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d70fbe",
  null
  
)

export default component.exports